'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherAlertTriangle, FeatherXCircle } from '@subframe/core';
import { useEffect, useState } from 'react';
import { Button, Dialog, TextArea } from '@/shared/components/ui';
import type { Fatura } from '../types';
import { formatarDataCurta, formatarMoedaBR } from '../utils/faturaFormatters';
const MIN_MOTIVO = 15;
interface CancelarFaturaModalProps {
  isOpen: boolean;
  fatura: Fatura | null;
  saving: boolean;
  onClose: () => void;
  onConfirm: (motivo: string) => void;
}
export function CancelarFaturaModal(t0) {
  const $ = _c(67);
  const {
    isOpen,
    fatura,
    saving,
    onClose,
    onConfirm
  } = t0;
  const [motivo, setMotivo] = useState("");
  const [ciente, setCiente] = useState(false);
  let t1;
  let t2;
  if ($[0] !== isOpen) {
    t1 = () => {
      if (isOpen) {
        setMotivo("");
        setCiente(false);
      }
    };
    t2 = [isOpen];
    $[0] = isOpen;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!fatura) {
    return null;
  }
  let t3;
  if ($[3] !== motivo) {
    t3 = motivo.trim();
    $[3] = motivo;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const motivoValido = t3.length >= MIN_MOTIVO;
  const podeConfirmar = motivoValido && ciente && !saving;
  let t4;
  if ($[5] !== motivo) {
    t4 = motivo.trim();
    $[5] = motivo;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const caracteresFaltantes = Math.max(0, MIN_MOTIVO - t4.length);
  let t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="bg-error-50 flex h-10 w-10 shrink-0 items-center justify-center rounded-full"><FeatherXCircle className="text-error-600 h-5 w-5" /></div>;
    t6 = <h2 className="text-body-bold font-body-bold text-default-font">Cancelar fatura</h2>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  let t7;
  if ($[9] !== fatura.numero || $[10] !== fatura.tenantNome) {
    t7 = <div className="flex items-start gap-3">{t5}<div>{t6}<p className="text-caption font-caption text-subtext-color mt-1">{fatura.tenantNome} · {fatura.numero}</p></div></div>;
    $[9] = fatura.numero;
    $[10] = fatura.tenantNome;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <p className="text-caption font-caption text-subtext-color">Valor</p>;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== fatura.valorTotal) {
    t9 = formatarMoedaBR(fatura.valorTotal);
    $[13] = fatura.valorTotal;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t9) {
    t10 = <div>{t8}<p className="text-body-bold font-body-bold text-default-font mt-1">{t9}</p></div>;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <p className="text-caption font-caption text-subtext-color">Vencimento</p>;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== fatura.dataVencimento) {
    t12 = formatarDataCurta(fatura.dataVencimento);
    $[18] = fatura.dataVencimento;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12) {
    t13 = <div>{t11}<p className="text-body-bold font-body-bold text-default-font mt-1">{t12}</p></div>;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t10 || $[23] !== t13) {
    t14 = <div className="grid grid-cols-2 gap-3 rounded-[12px] bg-neutral-50 p-4">{t10}{t13}</div>;
    $[22] = t10;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="border-error-200 bg-error-50 flex items-start gap-3 rounded-[8px] border px-4 py-3 text-sm"><FeatherAlertTriangle className="text-error-600 mt-0.5 h-4 w-4 shrink-0" /><p className="text-error-800">A cobrança correspondente no Asaas será cancelada automaticamente — o cliente deixa de receber lembretes. Esta ação fica registrada no histórico e não pode ser desfeita.</p></div>;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <label className="text-sm font-medium text-neutral-700">Motivo do cancelamento *</label>;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = e => setMotivo(e.target.value);
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== motivo) {
    t18 = <TextArea><TextArea.Input placeholder={"Descreva o motivo do cancelamento (m\xEDn. 15 caracteres)"} value={motivo} onChange={t17} rows={3} /></TextArea>;
    $[28] = motivo;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== caracteresFaltantes || $[31] !== motivo) {
    t19 = caracteresFaltantes > 0 ? `Faltam ${caracteresFaltantes} ${caracteresFaltantes === 1 ? "caractere" : "caracteres"}` : `${motivo.trim().length} caracteres`;
    $[30] = caracteresFaltantes;
    $[31] = motivo;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== t19) {
    t20 = <p className="text-caption font-caption text-subtext-color">{t19}</p>;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t18 || $[36] !== t20) {
    t21 = <div className="flex flex-col gap-1.5">{t16}{t18}{t20}</div>;
    $[35] = t18;
    $[36] = t20;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = e_0 => setCiente(e_0.target.checked);
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== ciente) {
    t23 = <input type="checkbox" checked={ciente} onChange={t22} className="accent-error-600 mt-0.5 h-4 w-4 rounded border-neutral-300" />;
    $[39] = ciente;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <span className="text-sm text-neutral-700">Estou ciente que o cliente deixará de receber lembretes de cobrança</span>;
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  let t25;
  if ($[42] !== t23) {
    t25 = <label className="flex cursor-pointer items-start gap-3">{t23}{t24}</label>;
    $[42] = t23;
    $[43] = t25;
  } else {
    t25 = $[43];
  }
  let t26;
  if ($[44] !== onClose || $[45] !== saving) {
    t26 = <Button variant="neutral-secondary" size="medium" onClick={onClose} disabled={saving}>Voltar</Button>;
    $[44] = onClose;
    $[45] = saving;
    $[46] = t26;
  } else {
    t26 = $[46];
  }
  let t27;
  if ($[47] !== motivo || $[48] !== onConfirm) {
    t27 = () => onConfirm(motivo.trim());
    $[47] = motivo;
    $[48] = onConfirm;
    $[49] = t27;
  } else {
    t27 = $[49];
  }
  const t28 = !podeConfirmar;
  let t29;
  if ($[50] !== saving || $[51] !== t27 || $[52] !== t28) {
    t29 = <Button variant="destructive-primary" size="medium" onClick={t27} loading={saving} disabled={t28}>Confirmar cancelamento</Button>;
    $[50] = saving;
    $[51] = t27;
    $[52] = t28;
    $[53] = t29;
  } else {
    t29 = $[53];
  }
  let t30;
  if ($[54] !== t26 || $[55] !== t29) {
    t30 = <div className="flex items-center justify-end gap-2 border-t border-neutral-100 pt-4">{t26}{t29}</div>;
    $[54] = t26;
    $[55] = t29;
    $[56] = t30;
  } else {
    t30 = $[56];
  }
  let t31;
  if ($[57] !== t14 || $[58] !== t21 || $[59] !== t25 || $[60] !== t30 || $[61] !== t7) {
    t31 = <Dialog.Content className="max-w-lg"><div className="flex w-full flex-col gap-5 p-6">{t7}{t14}{t15}{t21}{t25}{t30}</div></Dialog.Content>;
    $[57] = t14;
    $[58] = t21;
    $[59] = t25;
    $[60] = t30;
    $[61] = t7;
    $[62] = t31;
  } else {
    t31 = $[62];
  }
  let t32;
  if ($[63] !== isOpen || $[64] !== onClose || $[65] !== t31) {
    t32 = <Dialog open={isOpen} onOpenChange={onClose}>{t31}</Dialog>;
    $[63] = isOpen;
    $[64] = onClose;
    $[65] = t31;
    $[66] = t32;
  } else {
    t32 = $[66];
  }
  return t32;
}